export const dict = {
	custom: {
		name: {
			required: "Please enter your first name here",
		},
		address: {
			required: "Please enter your address here",
		},
		phone: {
			required: "Please enter your phone here",
			numeric: "Your phone may only contain numeric characters",
		},
		nit: {
			required: "Please enter your nit here",
		},
		date_init: {
			required: "The Date init is required",
			truthy_date_init: "La fecha inicial no puede ser mayor que la fecha final.",
		},
		contac_persons: {
			required: "Please enter your contac persons",
			alpha: "Your contac_persons may only contain alphabetic characters valid",
		},
		city: {
			required: "Please enter your city here",
		},
		country: {
			required: "Please enter your conuntry here",
		},
		description: {},
		date_end: {
			truthy: "La fecha final debe ser mayor que la fecha inicial.",
		},
	},
};
